import DiagonalLine from "../../../../DiagonalLine";

type HeaderColumn = {
  label: string;
  key: string;
  style?: React.CSSProperties;
  styleRow?: React.CSSProperties;
  render?: (value: any, row: any) => React.ReactNode;
  groups?: {
    label: string;
    key: string;
    style?: React.CSSProperties;
    styleRow?: React.CSSProperties;
  }[];
};

const ServiceBenefitLimitManagement = () => {
  const headerColumns = [
    {
      label: "サービス種類",
      key: "serviceType1",
      style: {
        width: "16mm",
      },
      styleRow: {
        width: "16mm",
      },
    },
    {
      label: "種類支給限度\n基準額（単位）",
      key: "typeLimitStandardUnits1",
      style: {
        width: "20mm",
        textAlign: "left",
      },
      styleRow: {
        width: "20mm",
      },
    },
    {
      label: "合計単位数",
      key: "totalUnits1",
      style: {
        width: "16mm",
      },
      styleRow: {
        width: "16mm",
      },
    },
    {
      label: "種類支給限度基準\nを超える単位数",
      key: "typeLimitExceededUnits1",
      style: {
        width: "20mm",
        borderRight: "2px solid black",
      },
      styleRow: {
        width: "20mm",
      },
    },
    {
      label: "サービス種類",
      key: "serviceType2",
      style: {
        width: "16mm",
      },
      styleRow: {
        width: "16mm",
      },
    },
    {
      label: "種類支給限度\n基準額（単位）",
      key: "typeLimitStandardUnits2",
      style: {
        width: "20mm",
        textAlign: "left",
      },
      styleRow: {
        width: "20mm",
      },
    },
    {
      label: "合計単位数",
      key: "totalUnits2",
      style: {
        width: "16mm",
      },
      styleRow: {
        width: "16mm",
      },
    },
    {
      label: "種類支給限度基準 \n を超える単位数",
      key: "typeLimitExceededUnits2",
      style: {
        width: "20mm",
      },
      styleRow: {
        width: "20mm",
      },
    },
  ] as HeaderColumn[];
  const data = [{}, {}, {}, {}, {}, {}] as any[];

  const renderTableHeader = (headerColumns: HeaderColumn[]) => {
    return (
      <thead>
        <tr>
          {headerColumns.map((column) => {
            return (
              <th
                key={column.key}
                style={{ ...column.style }}
                className="p-0 py-1 text-center whitespace-pre-line text-[9px] font-normal leading-[1.1] ]"
              >
                <div className="flex justify-center">{column.label}</div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };
  const renderLastRow = () => {
    return (
      <tr>
        <td className="text-right text-[11px]"></td>
        <td className="text-right text-[11px]"></td>
        <td className="text-right text-[11px]"></td>
        <td
          className="text-right text-[11px]"
          style={{ borderRight: "2px solid black" }}
        ></td>
        <td
          className="leading-[1.2] text-sm min-h-[7mm] p-0"
          style={{
            borderTop: "2px solid black",
          }}
        >
          <div className="min-h-[7mm] flex items-center">合計</div>
        </td>
        <DiagonalLine
          colSpan={2}
          strokeWidth={2}
          style={{
            borderTop: "2px solid black",
          }}
        />
        <td
          className="text-right leading-[1.2]"
          style={{
            borderTop: "2px solid black",
          }}
        >
          0
        </td>
      </tr>
    );
  };

  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, index) => (
          <tr key={index} className="border-b border-black">
            {headerColumns.map((column) => {
              return (
                <td
                  key={column.key}
                  className="p-0"
                  style={{ fontSize: 11, lineHeight: "1.2", ...column.style }}
                >
                  <div className="min-h-[7mm]" style={{ ...column.styleRow }}>
                    {column.render
                      ? column.render(row[column.key], row)
                      : row[column.key]}
                  </div>
                </td>
              );
            })}
          </tr>
        ))}

        {renderLastRow()}
      </tbody>
    );
  };

  return (
    <div>
      <div className="ml-5 text-xs">種類別支給限度管理</div>
      <table className="mt-[0.5mm] table-fixed">
        {renderTableHeader(headerColumns)}
        {renderTableBody()}
      </table>
    </div>
  );
};

export default ServiceBenefitLimitManagement;
